<template>
  <component-wrapper>
    <div
      :class="{
        'section-divider-fi': true,
        'section-divider-fi--dark': isDark,
        'section-divider-fi--extra-small': getSize === 'extra-small',
        'section-divider-fi--small': getSize === 'small',
        'section-divider-fi--large': getSize === 'large',
      }"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import { useSsrOnly } from '@/composables/ssrOnly';

defineOptions({ name: 'SectionDividerFi' });

const props = withDefaults(
  defineProps<{
    fields?: Record<string, any> | null;
    size?: string | null;
    dark?: boolean;
    markSsrOnly?: () => void;
  }>(),
  {
    fields: null,
    size: null,
    dark: false,
    markSsrOnly: undefined,
  },
);

useSsrOnly(props);

const isDark = computed(() => {
  if (props.fields?.dark?.value) {
    return Boolean(props.fields?.dark?.value);
  }
  return props.dark;
});

const getSize = computed(() => {
  if (props.fields?.size?.value) {
    return props.fields?.size?.value;
  }
  return props.size;
});
</script>

<style src="./section-divider-fi" />
